import { Component, EventEmitter, Input, OnInit, Output, Renderer2, ViewEncapsulation } from '@angular/core';
import { Device } from '@ionic-native/device/ngx';
import { switchMap } from 'rxjs/operators';
import { FileService } from 'src/app/services/file-service/file.service';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { PrifactRoute } from '../../../../../models/prifact-route';
import { RoutingService } from '../../../../../services/routing-service/routing.service';
import { Message } from '../../models/message';
import { MessagesService } from '../../services/message-service/messages.service';
import { SettingsService } from 'src/app/services/settings/settings.service';

@Component({
  selector: 'app-reply',
  templateUrl: './reply.component.html',
  styleUrls: ['./reply.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReplyComponent extends ComponentBase implements OnInit {

  constructor(private messageService: MessagesService
    , private renderer: Renderer2
    , public device: Device
    , private fileService: FileService
    , private routingService: RoutingService
    , private settingsService: SettingsService) {
    super();
  }

  @Input()
  selectedMessage: Message;
  @Output() onReplyComplete: EventEmitter<boolean> = new EventEmitter();

  subject: string;
  message: string;
  isSubmitClicked: boolean;
  selectedFile: File;
  supportedContentTypes: Array<string>;
  maxFileSize: Number;

  ngOnInit() {
    if (!this.selectedMessage) {
      let route = new PrifactRoute();
      route.url = '/pages/messages';
      route.clear_history = true;
      this.routingService.navigate(route);
    }
    else {
      this.subject = this.selectedMessage.subject.startsWith("RE: ") ? this.selectedMessage.subject : "RE: " + this.selectedMessage.subject;
    }
    let sub1 = this.settingsService.getSettings()
      .subscribe(res => {
        this.supportedContentTypes = res.home_work_content_types;
        this.maxFileSize = res.homework_file_max_size;
      });
    this.addSubscription(sub1);
  }

  submitClicked() {
    this.isSubmitClicked = true;
    return this.isSubmitClicked
  }

  onSubmit() {
    let toPersons: Array<string> = [];
    let toPersonGroups: Array<string> = [];
    let toStudentGroups: Array<string> = [];
    toPersons.push(this.selectedMessage.from_person_guid);
    let subscription = this.fileService.uploadFile(this.selectedFile).pipe(
      switchMap((file) => {
        return this.messageService.sendMessage(this.subject, this.message, toPersons, toPersonGroups, toStudentGroups, file);
      })
    )
      .subscribe(res => {
        this.onReplyComplete.emit(true);
        this.redirectBack();
      }, error => {
        console.error(error);
        this.onReplyComplete.emit(true);
      });
    this.addSubscription(subscription);
  }

  onCancel() {
    this.onReplyComplete.emit(true);
    this.redirectBack();
  }

  redirectBack() {
    let route = new PrifactRoute();
    route.url = "/pages/messages/" + this.selectedMessage.message_id;
    route.clear_history = true;
    this.routingService.navigate(route);
    this.renderer.removeClass(document.body, "second-page");
  }

  onFileSelect(files: Array<File>) {
    this.selectedFile = files[0];
  }

  fileRemoved(i: number) {
    this.selectedFile = null;
  }
}
